module.exports = __webpack_public_path__ + "static/media/BuiltSmartLogo.b1cd934c.svg";